(function () {
  function initFaqPage(root) {
    var selector = root.querySelector('[data-faq-category-selector]');
    var searchInput = root.querySelector('[data-faq-search]');
    var groups = root.querySelectorAll('[data-faq-category-group]');
    if (!groups.length) return;

    var buttons = selector ? selector.querySelectorAll('[data-faq-filter]') : [];
    var currentFilter = 'all';

    function setActiveButton(filter) {
      currentFilter = filter;
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-faq-filter') === filter);
      });
    }

    function applyCategoryFilter(filter) {
      groups.forEach(function (group) {
        var matches = filter === 'all' || group.getAttribute('data-faq-category-group') === filter;
        group.style.display = matches ? '' : 'none';
      });
    }

    function applySearchFilter(query) {
      var items = root.querySelectorAll('[data-faq-question]');
      var normalized = query.trim().toLowerCase();

      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        var text = summary ? summary.textContent.toLowerCase() : '';
        var matches = !normalized || text.indexOf(normalized) !== -1;
        item.style.display = matches ? '' : 'none';
      });

      groups.forEach(function (group) {
        var visibleItem = group.querySelector('[data-faq-question]:not([style*="display: none"])');
        var categoryMatches = currentFilter === 'all' || group.getAttribute('data-faq-category-group') === currentFilter;
        group.style.display = categoryMatches && (!normalized || visibleItem) ? '' : 'none';
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-faq-filter');
        setActiveButton(filter);
        applyCategoryFilter(filter);

        if (searchInput) {
          searchInput.value = '';
        }

        if (filter === 'all') {
          history.replaceState(null, '', window.location.pathname);
        } else {
          history.replaceState(null, '', '#' + filter);
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        applySearchFilter(this.value);
      });
    }

    var clearBtn = root.querySelector('[data-faq-search-clear]');
    if (clearBtn && searchInput) {
      clearBtn.addEventListener('click', function () {
        searchInput.value = '';
        applySearchFilter('');
      });
    }

    function applyFromHash() {
      var hash = window.location.hash.replace('#', '');
      var matchingGroup = hash
        ? root.querySelector('[data-faq-category-group="' + hash + '"]')
        : null;

      if (matchingGroup) {
        setActiveButton(hash);
        applyCategoryFilter(hash);
        setTimeout(function () {
          matchingGroup.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      } else {
        setActiveButton('all');
        applyCategoryFilter('all');
      }
    }

    applyFromHash();
    window.addEventListener('hashchange', applyFromHash);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq-root]').forEach(initFaqPage);
  });
})();